import { FC } from 'react';
import MinkaAllocateLedgerRegister from './MinkaAllocateLedgerRegister';
import UseMinkaAllocateLedgerRegister from './UseMinkaAllocateLedgerRegister';

const MinkaAllocateLedgerRegisterContainer: FC = () => {
  return <MinkaAllocateLedgerRegister {...UseMinkaAllocateLedgerRegister()} />;
};

export default MinkaAllocateLedgerRegisterContainer;
